var FileView = require('fileview');

var FileInlineView = FileView.extend({
    tagName: 'span',
    events: _.extend({}, FileView.prototype.events, {
        'click a.fileClose': 'clickClose',
        'click a.retry': 'retryUpload'
    }),
    clickClose: function (e) {
        e.preventDefault();
        this.collapse(true);
    },
    retryUpload: function (e) {
        e.preventDefault();
        if (!this.model.isUploaded()) {
            var promise = this.model.upload();
            this.trigger('finalise', promise, this);
        }
    },
    collapse: function (animate) {
        this.$('.media').each(function (i, m) {
            m.pause();
        });
        if (animate) {
            this.$el.slideUp(100).fadeOut(_.bind(function () {
                this.trigger('collapsed');
            }, this));
        } else {
            this.$el.hide();
            this.trigger('collapsed');
        }
    },
    sizeImage: function (img, dimensions) {
        img.attr({
            src: this.model.getCachedUrl(dimensions),
            width: dimensions.width,
            height: dimensions.height
        });
    },
    sizeDummy: function (dummy, dimensions) {
        dummy.css({
            width: dimensions.width,
            'line-height': dimensions.height + 'px'
        });
    },
    render: function (container) {
        var link = $('<a target="_blank" class="fileLink previewLink">');
        var close, media;
        if (this.model.isPreviewableImage()) {
            this.$el.addClass('imagePreview');
            var img = $('<img class="filePreview image loading">');
            var dummy = $('<div class="filePreviewImageDummy">').append('<i class="spin">');
            var dimensions = this.inlinePreviewDimensions(container);
            if (dimensions) {
                this.sizeImage(img, dimensions);
                this.sizeDummy(dummy, dimensions);
            } else {
                img.attr({
                    src: this.model.getCachedUrl({width: FileView.MAX_WIDTH})
                }).one('load', _.bind(function (e) {
                    var containerWidth = container.width();
                    dimensions = FileView.constrainDimensions(
                        img[0].width,
                        img[0].height,
                        FileInlineView.MAX_WIDTH_INLINE_RATIO * containerWidth,
                        FileInlineView.MAX_HEIGHT_INLINE
                    );
                    this.sizeImage(img, dimensions);
                    this.sizeDummy(dummy, dimensions);
                }, this));
            }
            link.append(img);
            link.append(dummy);
            close = '<a href="" class="embedClose" title="Close image"></a>';
        } else {
            link.addClass('docLink');
            link.append(this.docIcon());
            if (this.model.isPreviewableMedia()) {
                this.$el.addClass('mediaPreview');
                var closeText;
                if (this.model.isVideo()) {
                    media = $('<video class="video">');
                    closeText = 'Close video';
                } else if (this.model.isAudio()) {
                    media = $('<audio class="audio">');
                    closeText = 'Close audio';
                }
                media.addClass("filePreview media loading").attr({
                    preload: 'metadata',
                    controls: true,
                    src: this.model.getUrl()
                }).click(_.bind(function (e) {
                    e.preventDefault();
                    var v = e.target;
                    if (v.paused) {
                        v.play();
                    } else {
                        v.pause();
                    }
                }, this));
                close = '<a href="" class="embedClose" title="' + closeText + '"></a>';
            } else {
                this.$el.addClass('docPreview');
            }
        }
        this.$el.append(link);
        
        if (media) {
            this.$el.append(media);
        }
        
        if (close) {
            this.$el.append(close);
        }

        this.editForm = this.renderEditForm();
        this.$el.append(this.editForm);

        var info = this.renderInlineInfo();

        var actions = this.renderActions();
        info.append(actions);

        this.$el.append(info);

        this.editError = $('<p class="userError editError">');
        this.$el.append(this.editError);

        this.rendered();

        return this;
    },
    renderActions: function (noEdit) {
        var actions = $('<span class="actions">');
        if (!noEdit && this.model.isOwn()) {
            actions.append($('<a href="" class="edit">').text('edit'));
            actions.append(' • ');
            actions.append($('<a href="" class="delete">').text('delete'));
            actions.append($('<a href="" class="restore">').text('restore'));
            actions.append(' • ');
        }
        actions.append($('<a href="" class="fileClose">').text('close'));
        return actions;
    },
    renderEditForm: function () {
        var nameInput = $('<input class="input nameInput" name="name">');
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">').append(nameInput).append(editSubmit).append(editCancel));
    },
    renderInlineInfo: function () {
        var info = $('<span class="info">');
        var link = $('<a target="_blank" class="fileLink">');

        this.name = $('<span class="name">');
        link.append(this.name);

        var fileInfo = $('<span class="explanation">');
        fileInfo.text(this.model.getSize() + ' • ' + this.model.getType());
        link.append(fileInfo);

        info.append(link);
        return info;
    },
    inlinePreviewDimensions: function (container) {
        if (this.model.isPreviewableImage()) {
            var containerWidth = container.width();
            return this.constrainDimensions(
                FileInlineView.MAX_WIDTH_INLINE_RATIO * containerWidth,
                FileInlineView.MAX_HEIGHT_INLINE
            );
        } else {
            return {
                width: FileInlineView.INLINE_DOC_WIDTH,
                height: FileInlineView.INLINE_DOC_HEIGHT + FileInlineView.INLINE_INFO_HEIGHT
            };
        }
    },
    renderLocalInlineProgress: function (promise, options) {
        var progress = $('<span class="progress">');
        promise.progress(_.bind(function (evt, percentComplete) {
            progress.stop();
            if (evt) {
                progress.removeClass('busy');
                progress.animate({
                    height: percentComplete + '%'
                });
            } else {
                progress.addClass('busy');
                progress.css('height', '100%');
            }
        }, this));
        promise.fail(_.bind(function () {
            progress.removeClass('busy');
            progress.css('height', 0);
        }, this));
        return progress;
    },
    renderLocalInlinePreview: function () {
        return this.renderLocalPreview('image loading').done(_.bind(function (preview) {
            var info = this.renderInlineInfo();
            var actions = this.renderActions(true);
            actions.append($('<span class="retryWrap">')
                .append(' • ')
                .append($('<a href="" class="retry">').text('retry'))
            );
            info.append(actions);
            preview.append(info);

            var error = $('<p class="userError">');
            preview.append(error);
            this.renderName();
        }, this));
    }
}, {
    // Sync with css
    MAX_WIDTH_INLINE_RATIO: 0.92,
    MAX_HEIGHT_INLINE: 250,
    INLINE_DOC_WIDTH: 40,
    INLINE_DOC_HEIGHT: 50,
    INLINE_INFO_HEIGHT: 20
});

module.exports = FileInlineView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/fileinlineview.js
// module id = G5kp
// module chunks = 1